import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_FEES_MENU;

const CardFeesMenuLink: Array<LinkItemProps> = [
  {
    name: 'Frais Adhésion',
    link: URL.MEMBERSHIP_FEE,
    level: 3,
  },
  {
    name: 'Frais De Personnalisation',
    link: URL.CUSTOMIZATION_FEES,
    level: 3,
  },
  {
    name: 'Frais De Renouvellement',
    link: URL.RENEWAL_FEE,
    level: 3,
  },
  {
    name: 'Frais De Re-calcul Du Pin',
    link: URL.PIN_RECALCULATION_FEE,
    level: 3,
  },
  {
    name: 'Frais Divers',
    link: URL.MISCELLANEOUS_FEE,
    level: 3,
  },
  {
    name: 'Commission Carte',
    link: URL.CARD_COMMISSION,
    level: 3,
  },

];

export default CardFeesMenuLink;
